<template>
  <div class="container">
    <table
      width="1100"
      border="0"
      align="center"
      cellpadding="0"
      cellspacing="0"
      class="lianghui"
      style="margin: 0 auto"
      v-if="windowWidth > 769"
    >
      <tbody>
        <tr>
          <td
            width="270"
            valign="top"
            style="
              background-color: #f0efef;
              padding-top: 10px;
              padding-left: 10px;
            "
          >
            <div class="innerbox">
              <table
                width="100%"
                border="0"
                align="center"
                cellpadding="0"
                cellspacing="6"
              >
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">
                    <td width="26%">
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td width="74%" height="30">
                      <a :href="item.url" target="_blank" v-if="item.chnName">{{
                        item.chnName
                      }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td height="30">
                      <a href="/DRCNet.Channel.Web/subject/rd2006.asp"
                        >2006年两会系列专题</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td height="30">
                      <a href="/DRCNet.Channel.Web/subject/rd2005.asp"
                        >2005年两会系列专题</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td height="30">
                      <a href="/DRCNet.Channel.Web/subject/rd2004.asp?chnid=289"
                        >2004年两会系列专题</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td height="30">
                      <a href="/DRCNet.Channel.Web/subject/rd2004.asp?chnid=83"
                        >2003年两会系列专题</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td height="30">
                      <a href="/DRCNet.Channel.Web/subject/rd2004.asp?chnid=84"
                        >2002年两会系列专题</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <!-- background-color: #fdf9df; -->
          <td
            valign="top"
            align="center"
            class="background-style background-style-new-bac-img"
            style="position: relative"
          >
            <div class="top-banner">
              <div class="title">
                <img src="./images/TitleLabel.png" alt="" class="title-label" />
                <h1 class="title-content" v-if="list.length > 0">
                  {{ list[0].chnName }}
                </h1>
              </div>
              <div class="content-wrap">
                <div class="content-style">
                  <div
                    class="column-item"
                    v-for="(item, index) in columnList"
                    :key="index"
                  >
                    <a
                      target="_blank"
                      v-if="list.length > 0"
                      :href="`https://zhuanti.drcnet.com.cn/${list[0].chnName.substring(
                        0,
                        4
                      )}list?leafId=${item.id}`"
                    >
                      {{ item.name }}
                    </a>
                  </div>
                  <!-- <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29014"
                    >
                      宏观经济形势与政策
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29021"
                    >
                      大力发展数字经济
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29015"
                    >
                      更好统筹疫情防控和经济社会发展
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29022"
                    >
                      促进房地产市场平稳健康发展
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29016"
                    >
                      充分挖掘市场潜力 实施扩大内需战略
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29023"
                    >
                      持续激发市场主体活力
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29017"
                    >
                      加快前沿技术研发和应用推广培育壮大战略性新兴产业
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29024"
                    >
                      全面推进乡村振兴
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29018"
                    >
                      增强区域发展平衡性协调性
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29025"
                    >
                      落实落细就业优先 兜住兜牢民生底线
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29019"
                    >
                      防范金融风险 深化金融体制改革
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29026"
                    >
                      推动绿色发展 促进人与自然和谐共生
                    </a>
                  </div> -->
                  <div class="clear-both"></div>
                </div>
              </div>
              <div class="footer">
                <img class="logo" src="./images/logoborder.png" alt="" />
                <div>
                  Copyright © 1998-2023 DRCnet.&nbsp;All Rights Reserved
                </div>
                <div>版权所有 国研网</div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="windowWidth < 769"
      width="100%"
      border="0"
      align="center"
      cellpadding="0"
      cellspacing="0"
      class="lianghui"
      style="margin: 0 auto"
    >
      <div>
        <div>
          <div
            width="270"
            valign="top"
            style="
              background-color: #f0efef;
              padding-top: 10px;
              padding-left: 10px;
            "
          >
            <div class="innerbox">
              <table
                width="100%"
                border="0"
                align="center"
                cellpadding="0"
                cellspacing="6"
              >
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">
                    <td width="26%">
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td width="74%" height="30">
                      <a :href="item.url">{{ item.chnName }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td height="30">
                      <a href="/DRCNet.Channel.Web/subject/rd2006.asp"
                        >2006年两会系列专题</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td height="30">
                      <a href="/DRCNet.Channel.Web/subject/rd2005.asp"
                        >2005年两会系列专题</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td height="30">
                      <a href="/DRCNet.Channel.Web/subject/rd2004.asp?chnid=289"
                        >2004年两会系列专题</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td height="30">
                      <a href="/DRCNet.Channel.Web/subject/rd2004.asp?chnid=83"
                        >2003年两会系列专题</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div align="left">
                        <img src="./images/zt-rd1.jpg" width="45" height="32" />
                      </div>
                    </td>
                    <td height="30">
                      <a href="/DRCNet.Channel.Web/subject/rd2004.asp?chnid=84"
                        >2002年两会系列专题</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            valign="top"
            align="center"
            class="background-style"
            style="background-color: #fdf9df"
          >
            <div class="top-banner">
              <div class="title">
                <img src="./images/TitleLabel.png" alt="" class="title-label" />
                <h1 class="title-content" v-if="list.length > 0">
                  {{ list[0].chnName }}
                </h1>
              </div>
              <div class="content-wrap">
                <div class="content-style">
                  <div
                    class="column-item"
                    v-for="(item, index) in columnList"
                    :key="index"
                  >
                    <a
                      target="_blank"
                      v-if="list.length > 0"
                      :href="`https://zhuanti.drcnet.com.cn/${list[0].chnName.substring(
                        0,
                        4
                      )}list?leafId=${item.id}`"
                    >
                      {{ item.name }}
                    </a>
                  </div>
                  <!-- <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29020"
                    >
                      深化国资国企改革优化民营企业发展环境
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29014"
                    >
                      宏观经济形势与政策
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29021"
                    >
                      大力发展数字经济
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29015"
                    >
                      更好统筹疫情防控和经济社会发展
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29022"
                    >
                      促进房地产市场平稳健康发展
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29016"
                    >
                      充分挖掘市场潜力 实施扩大内需战略
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29023"
                    >
                      持续激发市场主体活力
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29017"
                    >
                      加快前沿技术研发和应用推广培育壮大战略性新兴产业
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29024"
                    >
                      全面推进乡村振兴
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29018"
                    >
                      增强区域发展平衡性协调性
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29025"
                    >
                      落实落细就业优先 兜住兜牢民生底线
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29019"
                    >
                      防范金融风险 深化金融体制改革
                    </a>
                  </div>
                  <div class="column-item">
                    <a
                      target="_blank"
                      href="https://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&chnid=7281&leafid=29026"
                    >
                      推动绿色发展 促进人与自然和谐共生
                    </a>
                  </div> -->
                  <div class="clear-both"></div>
                </div>
              </div>
              <div class="footer">
                <!-- <img
                  class="logo"
                  src="../../../../../../assets/imgs/public/logo.png"
                  alt=""
                /> -->
                <div>
                  Copyright o 1998-2023 DRCnet.&nbsp;All Rights Reserved
                </div>
                <div>版权所有 国研网</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <map name="Map">
      <area
        shape="rect"
        coords="42, 168, 380, 218"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29013"
        target="_blank"
      />
      <area
        shape="rect"
        coords="398, 168, 680, 216"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29020"
        target="_blank"
      />

      <area
        shape="rect"
        coords="42, 224, 380, 277"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29014"
        target="_blank"
      />
      <area
        shape="rect"
        coords="398, 227, 680, 277"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29021"
        target="_blank"
      />

      <area
        shape="rect"
        coords="42, 285, 380, 336"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29015"
        target="_blank"
      />
      <area
        shape="rect"
        coords="397, 283, 680, 334"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29022"
        target="_blank"
      />

      <area
        shape="rect"
        coords="42, 340, 380, 392"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29016"
        target="_blank"
      />
      <area
        shape="rect"
        coords="398, 339, 680, 392"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29023"
        target="_blank"
      />

      <area
        shape="rect"
        coords="42, 397, 380, 452"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29017"
        target="_blank"
      />
      <area
        shape="rect"
        coords="398, 398, 680, 451"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29024"
        target="_blank"
      />

      <area
        shape="rect"
        coords="42, 457, 380, 507"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29018"
        target="_blank"
      />
      <area
        shape="rect"
        coords="398, 456, 680, 508"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29025"
        target="_blank"
      />

      <area
        shape="rect"
        coords="42, 513, 380, 565"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29019"
        target="_blank"
      />
      <area
        shape="rect"
        coords="398, 513, 680, 562"
        href="http://misc.drcnet.com.cn/subject/meeting/channel_2023.aspx?currentYear=2023&amp;chnid=7281&amp;leafid=29026"
        target="_blank"
      />
    </map> -->
  </div>
</template>

<script>
import { getNPCandCPPCCDColumn, getChnidMenu } from "../../../../require/api";
export default {
  name: "NPCandCPPCC",
  data() {
    return {
      list: [],
      columnList: [],
    };
  },
  created() {
    this.getNPCandCPPCCDColumnData();
    // this.getRightMenuData();
  },
  methods: {
    async getNPCandCPPCCDColumnData() {
      const { data } = await getNPCandCPPCCDColumn({
        topNum: "100",
        chnid: "619",
      });
      if (data.code == 0) {
        this.list = data.data;
        // this.list.shift()
        this.getRightMenuData();
      }
    },
    async getRightMenuData() {
      if (this.list.length > 0) {
        const data2 = await getChnidMenu({ chnid: this.list[0].chnId });
        if (data2.data.data.code == 0) {
          this.columnList = data2.data.data.data;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
a {
  cursor: pointer;
}
.innerbox {
  overflow-y: auto;
  height: 700px;
  scrollbar-width: thin;
}
.lianghui a {
  color: black;
  font-size: 12px;
}
.background-style-new-bac-img {
  background-image: url(./images/lianghui_bj_new.jpg);
}
.top-banner {
  width: 100%;
  height: 100%;
  background-image: url(./images/lianghui_bj_new.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  padding: 16px;

  .title {
    width: 100%;
    position: relative;
    padding-top: 80px;
    margin-bottom: 34px;
    .title-label {
      position: absolute;
      top: 24px;
      left: 88px;
    }
    .title-content {
      font-size: 50px;
      font-weight: bolder;
      color: #e73233;
      -webkit-text-stroke: 2px white; /* Safari */
      text-stroke: 2px white;
      // font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
      //   Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
      //   sans-serif;
    }
  }
  .content-wrap {
    background-color: rgba(255, 255, 255, 0.5);
    width: 100%;
    padding: 16px;
    border-radius: 10px;
    .content-style {
      background-color: rgba(255, 255, 255, 0.8);
      width: 100%;
      border-radius: 10px;

      // display: flex;
      // flex-direction: row;
      // flex-wrap: wrap;
      padding: 16px;
      .column-item {
        width: 50%;
        float: left;
        color: black;
        font-size: 16px;
        font-weight: bolder;
        // -webkit-text-stroke: 0.5px white;
        // text-stroke: 0.5px white;
        // font-family: "element-icons";
        text-align: left;
        height: 64px;
        box-sizing: border-box;
        // line-height: 64px;
        padding-left: 20px;
        letter-spacing: 1px;
        display: flex;
        align-items: center;
        line-height: 24px;
        a {
          font-size: 17px;
        }
        // font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
        //   Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
        //   sans-serif;
        &:not(:nth-last-child(-n + 2)) {
          border-bottom: 1px dashed #dddddd;
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 60px;
    background-color: #b60000;
    position: relative;
    padding-top: 20px;
    margin-top: 32px;

    position: absolute;
    bottom: 0;
    left: 0;
    .logo {
      height: 40px;
      position: absolute;
      right: 32px;
      top: 10px;
    }
    div {
      text-align: center;
      color: white;
      font-size: 12px;
      font-family: "Courier New", Courier, monospace;
      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }
}
.clear-both {
  clear: both;
}
@media screen and (max-width: 769px) {
  .column-item {
    font-size: 12px !important;
    line-height: 16px !important;
    a {
      font-size: 12px !important;
    }
  }
  .footer {
    padding-top: 10px !important;
    bottom:auto !important;
  }
  .innerbox {
    height: 87px !important;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 5px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #535353;
    }

    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #ededed;
    }
  }
}
</style>